
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    CHANGE_PULS_CUSTOMER_SEARCH_ACCOUNTS_CTC_REQUEST,
    CHANGE_PULS_UPDATE_ACCOUNT_REQUEST,
    CHANGE_PULS_CUSTOMER_GET_DEVICE_REQUEST,
    CHANGE_PULS_CUSTOMER_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import {
    changePulsCustomerSearchAccountsResult,
    changePulsCustomerGetDeviceResult,
    changePulsCustomerResult
} from 'Redux/actions';


function* getDevice({ payload }) {
    try {
        const QUERY = `
        query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
            result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    label
                    esn
                    imei
                    unitConfig {
                        pulsCustomerId
                        calampApi
                    }
                    deviceModel {
                        id
                        name
                        manufacturerId
                        manufacturer {
                            id
                            name
                        }
                    }
                }
                total
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["esn", "imei"],
                    terms: [payload],
                    exact: true
                },
                limit: 1,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(changePulsCustomerGetDeviceResult(data?.result))
        } else {
            yield put(changePulsCustomerGetDeviceResult({ error: true }))
        }

    } catch (exc) {
        yield put(changePulsCustomerGetDeviceResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/changePulsCustomer/redux/saga",
            "getDevice",
        )
    }
}

function* updatePulsCustomer({ payload }) {
    try {
        let { unitIds, pulsCustomerId } = payload
        let QUERY = `
            mutation {
                
            
        `;
        for (let index = 0; index < unitIds.length; index++) {

            QUERY += ` 
            
            unit${index}: updateUnit (id: ${unitIds[index]}, unitConfig: {pulsCustomerId: "${pulsCustomerId}"}, features: {}) {
                id
                unitConfig {
                    pulsCustomerId
                }
            }
        
        `;

        }

        QUERY += ` 
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {},
            endpoints.GRAPHQL_GENERAL,
        );
        if (data) { //data?.result
            yield put(changePulsCustomerResult({ updatePulsCustomer: true }))
        } else {
            yield put(changePulsCustomerResult({ updatePulsCustomer: false }))
        }

    } catch (exc) {
        yield put(changePulsCustomerResult({ updatePulsCustomer: false }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/changePulsCustomer/redux/saga",
            "updatePulsCustomer",
        )
    }
}

function* searchAccountsCTC() {
    try {
        const QUERY = `
            query searchCalampAccounts {
                result: searchCalampAccounts {
                    id
                    name
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {},
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) yield put(changePulsCustomerSearchAccountsResult(data?.result))
        else yield put(changePulsCustomerSearchAccountsResult([]))

    } catch (exc) {
        yield put(changePulsCustomerSearchAccountsResult([]))
        ExceptionManager(
            exc,
            "Modules/devices/.components/changeCalampAccount/redux/saga",
            "searchAccounts",
        )
    }
}

function* updateAccountCTC({ payload }) {

    try {
        let QUERY = `
            mutation updateCalampDevicesAccount ($esns: [String]!, $accountId: String!) {
                result: updateCalampDevicesAccount (esns: $esns, accountId: $accountId) {
                    esn
                    status
                    message
                }
            }
        `
        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result?.length) yield put(changePulsCustomerResult({ updatePulsCustomer: true }, data?.result))
        else yield put(changePulsCustomerResult({ updatePulsCustomer: false }))


    } catch (exc) {
        yield put(changePulsCustomerResult({ updatePulsCustomer: false }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/changePulsCustomer/redux/saga",
            "updateAccountCTC",
        )
    }
}

function* watchMethods() {
    yield takeEvery(CHANGE_PULS_CUSTOMER_GET_DEVICE_REQUEST, getDevice);
    yield takeEvery(CHANGE_PULS_CUSTOMER_REQUEST, updatePulsCustomer);
    yield takeEvery(CHANGE_PULS_CUSTOMER_SEARCH_ACCOUNTS_CTC_REQUEST, searchAccountsCTC);
    yield takeEvery(CHANGE_PULS_UPDATE_ACCOUNT_REQUEST, updateAccountCTC);
}



export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}